export const extendValue = <T>(def: T, extendFn: (def: T) => T) => {
  return extendFn(def);
};
